export default "__VITE_ASSET__CTCni40n__"